import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <Link to="/" className="inline-block mb-6">
              <span className="text-5xl font-bold font-heading text-foreground-50">073</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              073漫画网致力于为中文读者提供最优质的韩国漫画阅读体验。无删减、下拉式、全免费——我们让韩漫阅读变得简单而纯粹。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-500 hover:border-primary-500 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-links-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-500 hover:border-primary-500 transition-all cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-500 hover:border-primary-500 transition-all cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-500 hover:border-primary-500 transition-all cursor-pointer" aria-label="B站">
                <i className="ri-movie-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-label uppercase tracking-widest text-foreground-500 mb-5">快速导航</h4>
            <div className="grid grid-cols-2 gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">热血少年</Link>
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">浪漫爱情</Link>
              <Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">悬疑惊悚</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-label uppercase tracking-widest text-foreground-500 mb-5">联系方式</h4>
            <div className="space-y-4">
              <div>
                <p className="text-xs text-foreground-500 mb-1">联系邮箱</p>
                <a href="mailto:hello@heiliaoapp.cn" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">hello@heiliaoapp.cn</a>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-1">商务合作</p>
                <a href="mailto:hello@heiliaoapp.cn" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">hello@heiliaoapp.cn</a>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-1">版权投诉</p>
                <a href="mailto:hello@heiliaoapp.cn" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">hello@heiliaoapp.cn</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/30">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 073漫画网 - 免费韩漫大全，无删减下拉式阅读
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}